import React from "react";
import { Mail, Phone, Linkedin } from "lucide-react";

const TeamMemberCard = ({
  name,
  position,
  image,
  email,
  phone,
  linkedin,
  bio,
}) => {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 group">
      <div className="relative overflow-hidden h-72">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
          <div className="transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 delay-150">
            <div className="flex space-x-3">
              {email && (
                <a
                  href={`mailto:${email}`}
                  className="bg-white/20 backdrop-blur-sm hover:bg-white/30 p-2 rounded-full transition-colors duration-200"
                  aria-label={`Email ${name}`}
                >
                  <Mail size={18} className="text-white" />
                </a>
              )}
              {phone && (
                <a
                  href={`tel:${phone}`}
                  className="bg-white/20 backdrop-blur-sm hover:bg-white/30 p-2 rounded-full transition-colors duration-200"
                  aria-label={`Call ${name}`}
                >
                  <Phone size={18} className="text-white" />
                </a>
              )}
              {linkedin && (
                <a
                  href={linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/20 backdrop-blur-sm hover:bg-white/30 p-2 rounded-full transition-colors duration-200"
                  aria-label={`${name}'s LinkedIn`}
                >
                  <Linkedin size={18} className="text-white" />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900">{name}</h3>
        <p className="text-psa-green-600 font-medium mb-3">{position}</p>
        <p className="text-gray-600">{bio}</p>
      </div>
    </div>
  );
};

export default TeamMemberCard;
